import { render, staticRenderFns } from "./FormRegister.vue?vue&type=template&id=187ea898&scoped=true&"
import script from "./FormRegister.vue?vue&type=script&lang=js&"
export * from "./FormRegister.vue?vue&type=script&lang=js&"
import style0 from "./FormRegister.vue?vue&type=style&index=0&id=187ea898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ea898",
  null
  
)

export default component.exports